/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField, CircularProgress, Typography, Link } from '@material-ui/core';
import { login } from 'src/redux/actions';
import { useAuth0 } from "../../react-auth0-spa";
import { green, red } from '@material-ui/core/colors';
import { Link as RouterLink } from 'react-router-dom';

const schema = {
	email: {
		presence: { allowEmpty: false, message: 'is required' },
		email: true
	},
	password: {
		presence: { allowEmpty: false, message: 'is required' }
	}
};

const useStyles = makeStyles((theme) => ({
	root: {},
	fields: {
		margin: theme.spacing(-1),
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			flexGrow: 1,
			margin: theme.spacing(1)
		}
	},
	submitButton: {

		width: '100%'
	},
	buttonProgress: {
		color: green[500],
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12,
	},
	wrapper: {
		marginTop: theme.spacing(2),
		margin: theme.spacing(1),
		position: 'relative',
	},
}));

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
	return new URLSearchParams(useLocation().search);
}

function LoginForm({ className, isRedirecting, ...rest }) {
	const classes = useStyles();
	const history = useHistory();
	const budgetState = useSelector(state => state.budget);


	let query = useQuery();

	const { loginWithRedirect, loading, isAuthenticated, logout, error } = useAuth0();

	useEffect(() => {
		if (!loading) {
			if (query.get('auto')) loginWithRedirect({});
			if (query.get('signup')) loginWithRedirect({ screen_hint: 'signup' });
		}

	}, [query, loading, loginWithRedirect]);

	const forceReload = () => {
		window.location.replace('/auth/login');
	}

	return (
		<div
			className={classes.wrapper}
		>
			{!error && <React.Fragment>
				{isAuthenticated &&
					<Button className={classes.submitButton}
						variant="contained"
						disabled={isRedirecting}
						onClick={() => logout({
							returnTo: window.location.protocol + '//' + window.location.host + '/auth/login'
						})}>Logout</Button>}
				{!isAuthenticated &&
					<React.Fragment>
						<Button
							id="loginButton"
							className={classes.submitButton}
							disabled={loading || budgetState.loading || isRedirecting}
							onClick={() => loginWithRedirect({})}
							variant="contained">Log in</Button>
						{(loading || budgetState.loading) && <CircularProgress size={24} className={classes.buttonProgress} />}
					</React.Fragment>
				}
			</React.Fragment>
			}
			{error && <React.Fragment>
				<Typography>There was a problem loading this page. Please <Link onClick={() => forceReload()} component={RouterLink} to='/auth/login'>reload</Link> to try again.</Typography></React.Fragment>}
		</div>
	);
}

LoginForm.propTypes = {
	className: PropTypes.string
};

export default LoginForm;
